import { propertyHomeTypeMap } from ".";
import formatAddress from "./propertyAddress";

export function getMetaDescription(property) {
  const {
    propertyHomeType = "property",
    noBedroom,
    noBathroom,
    address = "unknown location",
    propertySize,
    propertySizePostfix = "sqm",
    units
  } = property;

  const bedroomCount =
    noBedroom === undefined || noBedroom === null ? 0 : noBedroom;
  const bathroomCount =
    noBathroom === undefined || noBathroom === null ? 0 : noBathroom;

  const bedroomStr = `${bedroomCount} BR`;
  const bathroomStr = `${bathroomCount} BA`;
  const details = `${bedroomStr}, ${bathroomStr}`;

  const addressStr = formatAddress(address);
  const location = addressStr;

  const size = propertySize;
  const sizeUnit = propertySizePostfix;

  switch (propertyHomeType.toUpperCase()) {
    case "APARTMENTS":
    case "CONDOS_COOPS":
    case "RESIDENCE":
      return `For Sale: ${details} ${propertyHomeTypeMap[propertyHomeType]} in ${location} – ${size} ${sizeUnit}, ideal for city living.`;

    case "HOUSE":
    case "TOWNHOUSE":
      return `For Sale: ${details} ${propertyHomeTypeMap[propertyHomeType]} in ${location} – ${size} ${sizeUnit}, perfect for families or investors.`;

    case "DEVELOPMENT":
      return `Explore: New development in ${location} – ${details} units available. Register your interest today.`;

    case "LOTS_LANDS":
      return `For Sale: ${size} ${sizeUnit} land plot in ${location} – ${details} (land use not yet defined).`;

    case "MANUFACTURED":
      return `For Sale: ${details} manufactured home in ${location} – affordable and move-in ready.`;

    case "MULTI_FAMILY":
      return `For Sale: ${
        units || "Multiple"
      } unit multi-family property in ${location} – ${details}, ${size} ${sizeUnit}, perfect for investors.`;

    default:
      return `For Sale: ${details} property in ${location} – ${size} ${sizeUnit}.`;
  }
}
